import {SxType} from '@baseTypes/sx/sxTypes'

export default {
	header: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: '10px',
		mb: 1.5,
	},
	back: {
		textTransform: 'none',
		borderRadius: '8px',
	},
	title: {
		fontSize: '18px',
		fontWeight: 700,
	},
	description: {
		fontSize: '13px',
		color: 'text.secondary',
	},
	block: {
		borderRadius: '12px',
		border: '1px solid',
		borderColor: 'divider',
		padding: '12px',
		mb: 1.5,
		'.lightTheme &': {
			backgroundColor: '#fff',
		},
		'.darkTheme &': {
			backgroundColor: 'rgba(255, 255, 255, 0.04)',
		},
	},
	blockHead: {
		display: 'flex',
		alignItems: 'baseline',
		flexWrap: 'wrap',
		gap: '8px',
		mb: 1,
	},
	blockTitle: {
		fontSize: '14px',
		fontWeight: 700,
	},
} as const satisfies SxType
